/* eslint-disable import/prefer-default-export */

export const getScreenWidth = state => state.ui.screenSize.width;

export const isMobileDevice = state => state.ui.screenSize.isMobile;

export const isPhoneOrTabletDevice = state => state.ui.screenSize.isPhoneOrTablet;

export const getContentServiceRequestId = state => {
  return state.contentServiceRequestId;
};

export const getSupportMenuState = state => state.isSupportMenuOpen;

export const getMobileSupportMenuState = state => state.isMobileSupportMenuOpen;

export const getFocusedVideoId = state => state.focusedVideoId;

export default {
  isMobileDevice,
  isPhoneOrTabletDevice,
  getContentServiceRequestId,
  getSupportMenuState,
  getMobileSupportMenuState,
  getFocusedVideoId,
};
